export default {"src":"/evde-internet/_next/static/media/document.0512b239.svg","height":120,"width":120};